<template>
  <VList class="user-entries-component">
    <VListTile :to="{ name: USER_PROFILE_PAGE }">
      <VListTileAvatar>
        <KmIcon color="text" name="km-icon-profile" />
      </VListTileAvatar>
      <VListTileTitle class="text--text">
        Profile
      </VListTileTitle>
    </VListTile>

    <VListTile :to="{ name: BUCKETS_PAGE }">
      <VListTileAvatar>
        <KmIcon color="text" name="km-icon-buckets-list" />
      </VListTileAvatar>
      <VListTileTitle class="text--text">
        Buckets
      </VListTileTitle>
    </VListTile>

    <VListTile class="logout-link" @click="logout">
      <VListTileAvatar>
        <KmIcon color="error" name="km-icon-logout" />
      </VListTileAvatar>
      <VListTileTitle class="error--text">
        Logout
      </VListTileTitle>
    </VListTile>
  </VList>
</template>

<script>
import { USER_PROFILE_PAGE, BUCKETS_PAGE } from '@/router'
import * as act from '@/store/actions'
import KmIcon from '@/components/KmIcon'
import { trackLogout } from '@/tracking'

export default {
  name: 'UserEntries',
  components: {
    KmIcon,
  },
  data() {
    return { USER_PROFILE_PAGE, BUCKETS_PAGE }
  },
  computed: {
    backToV1Href() {
      const bucketId = this.$store.state.currentBucketId
      const hash = bucketId ? `#/bucket/${bucketId}/dashboard` : ''
      return `https://app.keymetrics.io/${hash}`
    },
  },
  methods: {
    logout() {
      trackLogout()
      this.$store.dispatch(act.LOGOUT)
    },
  },
}
</script>

<style lang="postcss" scoped>
.logout-link {
  cursor: pointer;
}
</style>
